"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    workOrderModel: {
        slots: {
            morning: 'Matin',
            afternoon: 'Après-midi'
        },
        status: {
            planed: 'Planifié',
            done: 'Réalisé',
            proceed: 'En cours',
            notProceed: 'Non réalisé',
            toBePlaned: 'A planifier'
        },
        engagement: {
            withRdv: 'Avec RDV',
            withoutRdv: 'Sans RDV'
        },
        reasons: {
            101: 'Indisponible',
            102: "Erreur d'affectation",
            103: 'Matériel manquant',
            104: 'Intervention déjà réalisée',
            105: 'Intempérie',
            106: 'Site ou compteur inaccessible',
            107: 'Refus du client',
            108: 'Client absent',
            109: 'Autorisation manquante',
            110: 'Impossibilité technique temporaire',
            111: 'Impossibilité technique permanente',
            112: 'Problème de sécurité',
            113: 'Erreur de diagnostic',
            114: 'Aucun problème identifié sur le terrain'
        }
    },
    geographicAddressModel: {
        building: 'Bâtiment',
        stairs: 'Escalier',
        floor: 'Etage',
        door: 'Porte'
    },
    cookiesConfig: {
        banner: {
            rejectCookiesLabel: 'Tout refuser',
            acceptCookiesLabel: 'Tout accepter',
            toggleMenuPanelLabel: 'Paramétrer vos cookies',
            infoText: 'Lors de votre navigation sur ce site, des cookies sont déposés pour assurer le fonctionnement du site, réaliser des statistiques de visite et faciliter votre identification à votre compte client.'
        },
        panel: {
            OptionsTitleList: 'Gérer les préférences des cookies',
            titlePanel: 'Centre de préférences de la confidentialité',
            contentPanel: 'Des cookies sont déposés sur votre ordinateur, smartphone ou tablette (ci-après l’« Appareil ») lors de la visite sur le site {weburl} . Les cookies sont des petits fichiers textes déposés sur votre Appareil dont le détail et les buts sont détaillés ci-dessous. Les cookies sont gérés par votre navigateur internet et seul l’émetteur d’un cookie est susceptible de lire ou de modifier les informations qui y sont contenues.',
            alwayActifLabel: 'Toujours actif',
            rejectAllCookiesLabel: 'Tout refuser',
            acceptAllCookiesLabel: 'Tout accepter',
            requiredCookie: {
                title: 'Cookies de fonctionnement',
                desc: 'Ces cookies sont nécessaires au fonctionnement du site et ne peuvent donc pas être refusés'
            },
            optionSession: {
                title: 'Cookies de session',
                desc: 'Ces cookies permettent de faciliter votre accès à votre compte client. Ces cookies ne sont pas indispensables à la navigation. Vous pouvez vous opposer à leur dépôt en les désactivant.'
            },
            optionAnalytic: {
                title: 'Cookies de mesure d’audience',
                desc: "Sous réserve de vos choix, ces cookies nous permettent de mesurer la fréquentation de notre site et ainsi l'adapter aux besoins de ses visiteurs. Ces cookies de mesure d'audience sont déposés via l'outil Matomo. Ces cookies ne sont pas indispensables à la navigation sur note site. Vous pouvez vous opposer à leur dépôt en les désactivant."
            },
            policyTitle: 'Politique cookies',
            policyMessage: 'Pour en savoir plus, consultez notre politique cookies:'
        }
    },
    login: {
        title: 'Connexion',
        submitButton: 'Me connecter',
        customerAreaSubtitle: 'Espace client',
        forgetPassword: 'Mot de passe oublié ?',
        CreateAccountTitle: "Vous n'avez pas d'espace client ?",
        CreateAccountButtton: 'Créer votre compte',
        UpdatePassWordButton: 'Modifier mon mot de passe',
        WelcomeTitle: 'Bienvenue dans votre espace client',
        WelcomeDesc: 'L’espace client vous permet de consulter vos données personnelles, votre relevé de compteur, le solde de votre compte, vos factures ainsi que les interventions prévues à votre domicile.',
        WelcomeBtnLabel: 'Revenir au site public',
        DiscoverAppLabel: 'Découvrez notre application Espace Client',
        timeoutSessionMessage: 'Votre session a expiré, veuillez-vous connecter à nouveau.',
        DiagnosticButton: 'Diagnostic de mon installation'
    },
    moveIn: {
        errors: {
            numberRequired: 'Ce champ ne doit contenir que des chiffres',
            numberIsTooHigh: 'Ce champ ne doit pas dépasser un maximum de {max}',
            numberIsTooLow: 'Ce champ ne doit pas être inférieur à {min}',
            fieldLengthTooShort: 'Ce champ doit contenir au moins {min} caractères',
            fieldLengthTooLong: 'Ce champ doit contenir au maximum {max} caractères'
        },
        billingAddress: {
            headerText1: 'Mon adresse de',
            headerText2: 'correspondance',
            sameAddressQuestion: 'Votre adresse de correspondance est-elle la même que l’adresse desservie ?',
            streetAddress: { label: 'N° et voie', placeholder: '' },
            zipCode: { label: 'Code postal', placeholder: '' },
            commune: { label: 'Ville', placeholder: '' },
            autoCompleteAddress: {
                label: 'Adresse de correspondance',
                placeholder: 'Je saisis mon adresse de correspondance'
            },
            precision: { label: 'Complément d’adresse', placeholder: '' },
            lieuDit: { label: 'Lieu-dit', placeholder: '' },
            cedex: { label: 'Cedex', placeholder: '' },
            country: { label: 'Pays', placeholder: '' }
        },
        meterAddress: {
            headerText1: 'Mon adresse',
            headerText2: 'desservie',
            streetNumber: { label: 'N°', placeholder: '' },
            streetAddress: { label: 'Voie', placeholder: '' },
            zipCode: { label: 'Code postal', placeholder: '' },
            commune: { label: 'Ville', placeholder: '' },
            autoCompleteAddressV2: {
                label: 'Adresse du branchement',
                placeholder: 'Je saisis l’adresse où se trouve mon compteur'
            },
            autoCompleteAddress: {
                label: 'Adresse desservie',
                placeholder: 'Je saisis mon adresse desservie'
            },
            addressComplement: {
                label: 'Complément d’adresse',
                placeholder: ''
            },
            building: { label: 'Bâtiment', placeholder: '' },
            stairs: { label: 'Escalier', placeholder: '' },
            floor: { label: 'Etage', placeholder: '' },
            door: { label: 'Porte', placeholder: '' },
            backButton: 'Retour au champ simplifié',
            cantFindMyAddress: 'Je ne trouve pas mon adresse'
        },
        residenceInfos: {
            residenceTypes: {
                main: 'Principale',
                secondary: 'Secondaire',
                commercial: 'Local commercial',
                mixed: 'Mixte'
            },
            ownershipTypes: {
                owner: 'Propriétaire',
                renter: 'Locataire'
            },
            waterUsageTypes: {
                domestical: 'Domestique',
                professional: 'Professionnelle',
                industrial: 'Industrielle'
            },
            lastOccupantQuestion: 'Connaissez-vous le nom de l’ancien occupant ?',
            runningWaterWarningQuestion: 'Avez-vous déjà de l’eau dans votre nouveau logement ?',
            runningWaterWarningPart1: 'Le manque d’eau peut être dû à la fermeture de votre robinet après compteur. Assurez-vous qu’il est ouvert !',
            runningWaterWarningPart2: 'S’il n’y a pas d’eau dans le logement, vous allez être recontacté prochainement pour prendre un rendez-vous.',
            ownershipStatus: { label: 'Je suis', placeholder: '' },
            flatCountInResidence: {
                label: 'Nombre de logements dans l’habitation',
                placeholder: 'Nombre de logements dans l’habitation'
            },
            numberOfInhabitants: {
                label: 'Nombre de personnes dans le foyer',
                placeholder: 'Exemple : 2 - Maximum : 12'
            },
            residenceType: {
                label: 'Résidence',
                placeholder: 'Je sélectionne mon type de résidence'
            },
            waterUsageType: { label: 'Usage de l’eau', placeholder: '' },
            runningWater: { label: '', placeholder: '' },
            knownLastOccupant: { label: '', placeholder: '' },
            formerOccupantLastName: {
                label: 'Nom',
                placeholder: 'Nom de l’ancien occupant du logement'
            },
            formerOccupantFirstName: {
                label: 'Prénom',
                placeholder: 'Prénom de l’ancien occupant du logement'
            },
            referenceClient: {
                label: 'Référence client',
                placeholder: 'La référence client de l’ancien occupant'
            },
            formerOccupant: {
                title: 'Ancien occupant',
                message: 'Je ne connais pas l’ancien occupant'
            }
        },
        stepper: {
            MyInformation: 'Mes informations',
            CoHolderHInformation: 'Informations du co-titulaire',
            MyMeterInfos: 'Mon compteur',
            MyMeterAddress: 'Mon adresse desservie',
            MyBillingAddress: 'Mon adresse de correspondance',
            MyConsumptionEstimation: 'Estimation de ma consommation',
            MyBillingInfos: 'Ma facturation'
        },
        loginWidgetTitle: "J'emménage",
        loginButton: "M'abonner",
        requiredFieldsNotice: '* Champs obligatoires',
        yesText: 'Oui',
        NoText: 'Non',
        title: {
            label: 'Civilité',
            mister: 'Monsieur',
            madame: 'Madame'
        },
        email: {
            label: 'Adresse email',
            placeholder: 'Mon adresse électronique',
            confirmationPlaceholder: 'Confirmation de mon adresse électronique'
        },
        birthDate: {
            label: 'Date de naissance'
        },
        birthCountry: {
            label: 'Pays de naissance',
            placeholder: 'Mon pays de naissance'
        },
        birthCity: {
            label: 'Ville de naissance',
            placeholder: 'Ma ville de naissance'
        },
        identityJustificationFile: {
            label: "Justificatif d'identité",
            selectButton: 'Ajouter un document',
            indocation: 'Formats acceptés: .pdf .jpg .png',
            deleteButton: 'Supprimer'
        },
        townEligibility: {
            headerTextPart1: 'Créer mon dossier',
            headerTextPart2: 'd’abonnement',
            eligibilityError: 'Cette commune n’est pas desservie par nos services. Veuillez vous rapprocher de votre mairie pour plus d’informations.',
            townInputLabel: 'Je renseigne mon code postal ou ma commune',
            townInputPlaceholder: '1 caractère minimum…'
        },
        publicSiteRedirect: {
            useOldWebsiteButton: 'Je m’abonne via l’espace public',
            privateClientOnlyOption: 'Cette option d’abonnement en ligne n’est pas encore disponible pour les sociétés et les administrations.',
            notSupportedCommuneError: 'Cette option d’abonnement en ligne n’est pas encore disponible pour votre commune.',
            pleaseUseOldWebsite: 'Merci d’utiliser le formulaire mis à disposition sur l’espace public.'
        },
        privateOrProfessional: {
            private: 'Un particulier',
            iAm: 'Je suis',
            professional: 'Une société, administration'
        },
        prerequiste: {
            readyButton: 'Je suis prêt',
            headerPart1: 'Afin de créer ma demande d’abonnement,',
            headerPart2: 'je dois me munir des éléments suivants :',
            counterText: 'Le numéro de mon compteur,  le relevé et la date de relevé, et une photo lisible du compteur.',
            identityCard: 'Une pièce d’identité et celle de mon éventuel co-titulaire (carte d’identité ou passeport).',
            creditCard: 'Un relevé d’identité bancaire (IBAN)'
        },
        myInfos: {
            header: 'Mes informations',
            firstName: {
                label: 'Prénom',
                placeholder_1: "Le prénom inscrit sur ma pièce d'identité",
                placeholder_2: "Le prénom inscrit sur ma pièce d'identité (30 caractères max)"
            },
            lastName: {
                label: 'Nom',
                placeholder_1: "Le nom inscrit sur ma pièce d'identité",
                placeholder_2: "Le nom inscrit sur ma pièce d'identité (30 caractères max)"
            },
            phone: 'Téléphones',
            landlinePhone: {
                label: 'Téléphone fixe',
                placeholder: 'Mon numéro de téléphone fixe'
            },
            mobilePhone: {
                label: 'Téléphone mobile',
                placeholder: 'Mon numéro de téléphone mobile'
            },
            acceptsEmailNewsletter: {
                label: "J'accepte de recevoir par email des communications et actualités relatives aux services de l'entreprise"
            },
            acceptsSmsNewsletter: {
                label: "J'accepte de recevoir par SMS des communications et actualités relatives aux services de l'entreprise"
            },
            indicator1: '(1) Votre email sera privilégié pour communiquer avec vous dans le cadre de votre contrat d’abonnement, en cas d’alertes de surconsommation ainsi que pour vous adresser des conseils et des informations concernant les nouveautés de Saur et de ses services. Vous pourrez vous rendre dans votre espace client pour gérer vos préférences.',
            indicator2: '(2) Un des deux numéros de téléphone est obligatoire. Votre numéro sera utilisé pour vous adresser des informations ou alertes concernant un événement nécessitant une attention particulière de votre part.',
            indicator3: "(3) En validant cette étape, vos données seront collectées et conservées pour une durée égale à un (1) mois. Dans le cadre de notre démarche d'amélioration de la qualité de nos services et de notre site, nos services internes sont susceptibles de vous contacter si vous ne finalisez pas votre abonnement sur notre site. Vous pouvez exercer votre droit d'accès, de rectification, d'opposition et d'effacement par e-mail à dpo@saur.com."
        },
        myCoInfos: {
            headerTextPart1: 'Informations',
            headerTextPart2: 'du co-titulaire',
            isWithJointAccountQuestion: 'Y a-t-il un co-titulaire sur le contrat ?',
            firstName: {
                label: 'Prénom',
                placeholder_1: "Le prénom inscrit sur sa pièce d'identité",
                placeholder_2: "Le prénom inscrit sur sa pièce d'identité (30 caractères max)"
            },
            lastName: {
                label: 'Nom',
                placeholder_1: "Le nom inscrit sur sa pièce d'identité",
                placeholder_2: "Le nom inscrit sur sa pièce d'identité (30 caractères max)"
            },
            email: {
                label: 'Adresse email',
                placeholder: 'Son adresse électronique',
                confirmationPlaceholder: 'Confirmation de son adresse électronique'
            },
            mobilePhone: {
                label: 'Téléphone mobile',
                placeholder: 'Son numéro de téléphone mobile'
            },
            landlinePhone: {
                label: 'Téléphone fixe',
                placeholder: 'Son numéro de téléphone fixe'
            },
            birthCountry: {
                label: 'Pays de naissance',
                placeholder: "Le pays de naissance inscrit sur sa pièce d'identité"
            },
            birthCity: {
                label: 'Ville de naissance',
                placeholder: "La ville de naissance inscrit sur sa pièce d'identité"
            }
        },
        meterInfos: {
            errorScreen: {
                title: 'Nous n’arrivons pas à identifier votre compteur.',
                newTitle: 'Nous n’arrivons toujours pas à identifier votre compteur.',
                newMessageOne: 'Pouvez-vous nous donner plus d’informations sur votre',
                newMessageTwo: 'adresse et/ou votre compteur ?',
                message: 'Une intervention de nos équipes sera peut-être nécessaire. Il est possible que vous soyez recontacté prochainement par un de nos conseillers de clientèle.'
            },
            additionalInformation: {
                label: 'Informations complémentaires.',
                placeholder: 'Précisions sur adresse/compteur (200 caractères Max)'
            },
            serialNumber: {
                label: 'Numéro du compteur',
                placeholder: '11 caractères du matricule compteur'
            },
            meterNumber: {
                label: 'Numéro du compteur',
                placeholder: 'Le numéro de mon compteur'
            },
            entryDate: {
                label: 'Date d’entrée dans le logement',
                placeholder: '    JJ     /     MM     /     AAAA'
            },
            meterIndex: {
                label: 'Je relève les 4 à 6 chiffres indiqués sur mon compteur',
                placeholder: '0 0 0 0'
            },
            meterPhoto: { label: 'Photo du compteur' },
            titlePart1: 'Mon',
            unknownMeterId: 'Nous n’arrivons pas à identifier votre compteur. Veuillez vérifier votre saisie avant de passer à l’étape suivante.',
            titlePart2: 'Compteur',
            addAPhoto: 'Ajouter une photo',
            nextButton: 'Passer à l’étape suivante',
            cancelButton: 'Annuler',
            meterInfosPopup: {
                myMeterIndex: 'Relevé de mon compteur',
                meterIndexPostion: 'Où trouver ces chiffres ?',
                meterIndexIndicationPart1: 'Dans la case « relevé du compteur », ',
                meterIndexIndicationPart2: 'reportez uniquement les 4 à 6 chiffres en blanc sur fond noir ou en noir sur fond blanc. ',
                meterIndexIndicationPart3: 'Ils constituent le relevé que vous retrouverez sur votre facture, exprimé en m3 (1 m3=1000 l)'
            },
            meterRegistrationPopup: {
                myMeterNumber: 'Numéro de mon compteur',
                meterNumberPostion: 'Où le trouver ?',
                meterNumberIndicationPart1: 'Dans la case « numéro du compteur », ',
                meterNumberIndicationPart2: 'reportez uniquement les 11 caractères présents sur votre compteur. ',
                meterNumberIndicationPart3: 'Il se peut que votre matricule compteur soit inscrit à un autre endroit que sur les deux exemples ci-dessus.'
            }
        },
        consEstimation: {
            headerTextPart1: 'Estimation de',
            headerTextPart2: 'ma consommation',
            isYearlyConsumptionKnownQuestion: 'Avez-vous une idée de votre consommation annuelle en m3 ?',
            yearlyConsumption: {
                label: 'Consommation annuelle'
            },
            numberOfInhabitants: {
                label: 'Nombre de personnes dans le foyer'
            },
            consumptionEstimateLabel: 'Estimation',
            consumptionEstimationInfo: "L'estimation de votre consommation est une étape importante : elle servira soit pour la mensualisation de votre facturation, soit pour vos factures intermédiaires.",
            consumptionEstimationNotice: '*Estimation basée sur une moyenne nationale par personne et le prix moyen de votre commune, ne comprenant pas les frais de service.',
            consumptionEstimateMonthlyValue: 'par mois',
            consumptionEstimateMiddleInfo: 'soit',
            consumptionEstimateTooHighError: 'Votre consommation ne semble pas correspondre à une consommation personnelle.',
            consumptionEstimateTooLowWarning: "Attention: vous ne comptez pas consommer d'eau de toute l'année.",
            consumptionEstimateClientService: 'Merci de prendre contact avec votre service client.',
            consumptionEstimateClientServiceButton: 'Contacter mon service client'
        },
        paymentInfos: {
            title: {
                firstpart: 'Ma',
                secondpart: 'facturation'
            },
            paymentType: {
                label: 'Mode de paiement',
                placeholder: 'Prélèvement mensuel'
            },
            iban: {
                label: 'IBAN'
            },
            withdrawalDay: {
                label: 'Jour du prélèvement',
                placeholder: 'Je sélectionne le jour de mon prélèvement'
            },
            paymentTypes: {
                monthly: 'Prélèvement mensuel',
                bill: 'Prélèvement sur facture',
                other: 'Autres moyens de paiement'
            },
            noticeMessage: {
                firstline: 'Vous pourrez régler votre facture par carte',
                secondline: 'bancaire directement sur votre espace client.'
            },
            billingInfos: {
                backtopayment: 'Retour sur mes choix de facturation',
                gotoebilling: 'Je passe gratuitement à la facture électronique',
                firsticonword: 'Je suis averti(e) par email de la mise à disposition de toute nouvelle facture',
                secondiconword: "J'y accède en ligne 24h/24 et 7j/7",
                thirdiconword: 'Je contribue à réduire la consommation des ressources naturelles',
                yesbutton: 'OUI',
                nobutton: 'Je ne suis pas intéressé(e)',
                cancelbutton: 'Annuler'
            }
        },
        recap: {
            headerTextPart1: 'Récapitulatif de',
            headerTextPart2: 'mes informations',
            myInformation: {
                identityLabel: 'Identité',
                dateOfBirthLabel: 'Date de naissance',
                countryOfBirthLabel: 'Pays de naissance',
                cityOfBirthLabel: 'Ville de naissance',
                emailLabel: 'Email',
                mobilePhoneLabel: 'Téléphone portable',
                landlineLabel: 'Téléphone fixe',
                acceptsEmailNewsletterOnly: "J'accepte de recevoir par email des communications et actualités relatives aux services de l’entreprise.",
                acceptsSmsNewsletterOnly: "J'accepte de recevoir par SMS des communications et actualités relatives aux services de l’entreprises.",
                acceptsEmailAndSmsNewsletters: "J'accepte de recevoir par email et SMS des communications et actualités relatives aux services de l’entreprises.",
                doesNotAcceptNewsletters: 'Je ne souhaite recevoir aucune communication ou actualité relative aux services de l’entreprises par email ou SMS.'
            },
            myCoInformation: {
                identityLabel: 'Identité',
                dateOfBirthLabel: 'Date de naissance',
                countryOfBirthLabel: 'Pays de naissance',
                cityOfBirthLabel: 'Ville de naissance',
                emailLabel: 'Email',
                mobilePhoneLabel: 'Téléphone mobile',
                landlineLabel: 'Téléphone fixe',
                noCoInfoMessage: 'Pas de co-titulaire sur le contrat.'
            },
            myMeterInfos: {
                serialNumberLabel: 'Numéro de compteur',
                entryDateLabel: 'Arrivée dans le logement',
                meterIndexLabel: 'Relevé du compteur'
            },
            myMeterAddress: {
                meterAddressLabel: 'Adresse du branchement',
                ownershipStatusLabel: 'Type de possession',
                flatCountInResidenceLabel: "Nb de logements dans l'habitation",
                numberOfInhabitantsLabel: 'Nb de personnes dans le foyer',
                residenceTypeLabel: 'Type de résidence',
                waterUsageTypeLabel: "Usage de l'eau",
                runningWaterLabel: "Il y a de l'eau dans le logement.",
                noRunningWaterLabel: "Pas d'eau dans le logement."
            },
            myBillingAddress: {
                billingAddressLabel: 'Adresse de correspondance',
                sameAsMeterAddressMessage: 'Mon adresse de correspondance est la même que l’adresse desservie.'
            },
            myConsEstimation: {
                yearlyConsumptionLabel: 'Consommation annuelle',
                numberOfInhabitantsLabel: "Nombre d'habitants"
            },
            myBillingInfos: {
                paymentTypeLabel: 'Mode de paiement',
                ibanLabel: 'IBAN',
                withdrawalDayLabel: 'Jour du prélèvement',
                eBillServiceLabel: 'Facture électronique',
                withdrawalDayValuePart2: 'du mois'
            }
        },
        conditionsValidation: {
            headerTextPart1: 'Validation',
            headerTextPart2: 'des conditions',
            firstConditionMessage: "Je certifie sur l'honneur l'exactitude des informations données et je reconnais que la présente commande vaut obligation de paiement.",
            secondConditionMessage: "Conformément à l'article L121-21-5 du Code de la consommation, l'alimentation en eau sera effective dans un délai de 14 jours à compter de la validation du présent contrat. Je demande donc l'exécution de la prestation de service avant la fin du délai de rétractation de 14 jours mentionné à l'article L121-21-5 du Code de la Consommation. Je suis informé(e) de mon obligation de payer toute prestation liée à la mise en service de mon branchement même en cas d'utilisation de mon droit de rétractation. Ce droit peut être exercé par simple envoi d'un courrier ou email.",
            consultRgpd: 'Pour en savoir plus, vous pouvez consulter ',
            consultRgpdLink: 'notre politique de protection des données personnelles.',
            errorMessage: 'Veuillez cocher les deux cases liées aux conditions ci-dessus avant de valider.'
        },
        moveInSuccess: {
            successMessage: 'FÉLICITATIONS!',
            requestMessage: 'Votre demande a bien été prise en compte!',
            processingMessage: 'Elle sera traitée dans les plus brefs délais par le service clientèle.'
        },
        moveInFailure: {
            errorMessage: "UNE ERREUR S'EST PRODUITE",
            errorDescriptionMessage: 'Un problème technique a empêché la validation de votre dossier.',
            tryAgainMessage: 'Veuillez réessayer.'
        },
        moveInCancel: {
            header: 'Annuler',
            warningMessage: 'Attention, toutes les informations saisies vont être perdues et votre dossier d’abonnement ne sera pas enregistré.'
        },
        buttons: {
            nextStep: "Passer à l'étape suivante",
            nextStepV2: "Passer à l'étape suivante (3)",
            nextStepV1: "Passer à l'étape suivante (1)",
            finalize: 'Finaliser mon contrat',
            validate: 'Valider',
            close: 'Fermer',
            abandon: 'Abandonner la création de mon dossier',
            revalidate: 'Valider la création de mon dossier',
            cancel: 'Annuler'
        }
    },
    ContractCancellation: {
        title: 'Résiliation de contrat',
        userIdentification: 'Mon authentification'
    },
    CreateAccount: {
        title: 'Créer mon espace client',
        invalidTokenError: 'Le lien utilisé est invalide. Veuillez réitérer votre demande de création de compte.',
        stepOneInThree: {
            referenceUsed: 'Cette référence client est déjà utilisée par un autre compte',
            stepOne: 'étape 1/3',
            numberClientReference: 'Ma référence client (10 chiffres)',
            whereToFindClientReference: 'Où la trouver ?',
            whereToFindFullClientName: 'Où le trouver ?',
            clientName: 'Mon nom (figurant sur ma facture)',
            clientFirstLastName: 'Mon nom et prénom (figurant sur ma facture)',
            notClientYet: 'Pas encore client ?',
            rdvHeading: 'Rendez-vous dans notre rubrique',
            iMoveIn: "J'emménage",
            legaleNotice: 'Saur, en tant que responsable de traitement, située 11, chemin de Bretagne - 92130 Issy-les-Moulineaux, met en œuvre un traitement de données à caractère personnel vous concernant pour permettre la création d’un compte, la gestion de votre abonnement via un espace dédié sur le site de Saur. En application de la réglementation applicable, vous bénéficiez d’un droit d’interrogation, d’accès, de rectification, d’effacement, de limitation du traitement, de portabilité des données, de retirer votre consentement au traitement à tout moment, et d’opposition ainsi que le droit de définir des directives relatives au sort de vos données après votre décès. Vous pouvez exercer ces droits auprès de Saur par email, à l’adresse dpo@saur.com. Ces droits peuvent également être exercés par courrier postal à l’adresse suivante : SAUR S.A.S., à l’attention du Délégué à la Protection des Données, 11 chemin de Bretagne 92130 Issy-les-Moulineaux. Pour en savoir plus, vous pouvez consulter notre politique de protection des données personnelles.',
            indicationToFindClientReference: 'Cette référence est disponible en haut à droite de votre facture',
            indicationToFindClientReferenceSubtitle: 'À reporter',
            helpNeededQuestion: "Besoin d'aide ?",
            writeUs: 'Ecrivez-nous via le',
            formContact: 'formulaire de contact',
            subscriptionPending: "Vos données ne sont pas encore disponibles sur l'espace client. Merci de réessayer ultérieurement.",
            helpFullClientName: {
                title: 'Les nom et prénom sont disponibles en haut à droite de votre facture',
                fullClientName: 'Nom et prénom du client'
            },
            subscriptionUnpermited: "Création de l'espace client impossible. Merci de contacter le service clientèle"
        },
        stepTwoInThree: {
            emailUsedError: 'Cette adresse e-mail est déjà utilisée par un autre compte',
            stepTwo: 'étape 2/3',
            helloWord: 'Bonjour',
            emailFieldLabel: 'Mon email',
            confirmEmailFieldLabel: 'Confirmer mon email',
            acceptWord: "J'accepte les",
            cgu: "Conditions Générales d'Utilisation",
            cguBrackets: '(CGU)',
            corporateCommunicationByEmail: 'J’accepte de recevoir par email des communications et actualités relatives aux services de l’entreprise',
            emailSend: 'Vous allez recevoir dans quelques instants un email à l’adresse',
            clickToFinalize: 'Cliquez sur le lien contenu dans cet email afin de finaliser la création de votre espace client Saur.',
            inscriptionNotFinalizedError: "Un mail pour la création de votre espace client vous a déjà été adressé à cette adresse. Celui-ci dont l'objet est 'finalisation de votre inscription' est actif pendant 24 heures. S’il n’apparaît pas dans votre boîte de réception, pensez à vérifier vos spams ou votre boîte “courrier indésirable”."
        },
        stepThreeInThree: {
            expiredLink: 'Le lien envoyé par mail a expiré, veuillez réessayer',
            sendMailAgainSuccess: 'Email renvoyé avec succès',
            linkActiveDuration: 'Ce lien est actif 24h',
            stepThree: 'étape 3/3',
            confirmEmailFieldLabel: 'Confirmer mon mot de passe',
            success: 'Félicitations !',
            successCreationClientAccount: 'Votre espace client a bien été créé.',
            backToConnexion: 'Revenir à la page de connexion'
        }
    },
    forgetPasswordScreen: {
        sessionError: 'Oups ! Votre session est expirée, veuillez recommencer la procédure.',
        stepEnterEmail: {
            title: 'Réinitialiser mon mot de passe',
            titleOnTwoLine: 'Réinitialiser\nmon mot de passe'
        },
        stepSendEmail: {
            title: 'Envoyé !',
            paragraphOnePartOne: "Si un compte a été créé avec l'adresse,",
            paragraphOnePartTwo: 'vous recevrez alors par email un lien pour réinitialiser votre mot de passe.',
            paragraphTwo: 'Cliquez sur le lien contenu dans cet email afin de réinitialiser votre mot de passe.',
            paragraphThree: 'Ce lien est actif 24h.',
            btnLabel: 'Revenir à la connexion',
            notSendingEmail: {
                title: 'Vous n’avez pas reçu d’email ?',
                linkLabel: 'Renvoyer le lien'
            },
            forgetEmailLink: "Je n'ai plus accès à mon adresse mail",
            errorMultipleChangeInYear: "Vous avez déjà réalisé deux modifications de prélèvement au cours des 12 derniers mois. Veuillez contacter le service clientèle pour plus d'informations.",
            errorPendingAOtherDemande: 'Vous avez déjà une demande en cours de traitement, celle-ci sera effective dans un délai de 72h.'
        },
        updatePasswordStep: {
            passwordFieldLabel: 'Choisir mon nouveau mot de passe',
            confirmPasswordField: 'Confirmer mon nouveau mot de passe'
        },
        updateSuccessStep: {
            title: 'Merci !',
            content: 'Votre mot de passe a été modifié avec succès.'
        },
        updateAdressStep: {
            title: 'Modifier mon adresse email {brand}',
            emailValidation: 'Identifiant à changer : {mail}',
            QuestionBtnValidLabel: 'Oui',
            QuestionBtnNotValidLabel: 'Non',
            textValidaton: "Je certifie être le propriétaire du compte rattaché à l'adresse mail {mail}.",
            btnValidation: 'Oui je le certifie',
            failure: {
                btnLabel: 'Contacter le service client',
                info: "Sans numéro de facture ou IBAN rattaché à ce compte, nous ne pouvons malheureusement pas faire aboutir votre demande d'accès à ce compte."
            },
            enterEmailToUpdate: {
                placeholder: 'Mon ancienne adresse mail',
                label: 'Mon identifiant à changer'
            },
            questionHaveBilling: {
                question: 'Avez-vous à votre disposition une facture de moins de 2 ans ?'
            },
            questionHaveDirectDebit: {
                question: 'Le compte bloqué est-il en prélèvement automatique ?'
            },
            ibanInput: {
                info: "Veuillez saisir les 5 derniers chiffres de l'IBAN rattaché à ce compte",
                inputLabel: 'IBAN (5 derniers chiffres)',
                inputPlaceholder: 'xx xx xxxxx xxxxx xxxxxx',
                inputPlaceholderNext: 'xxx xx',
                errorRequiredFiveNumber: 'Le champ doit contenir 5 chiffres'
            },
            billingNumberInput: {
                info: "Veuillez saisir le numéro d'une facture datée de moins de 2 ans",
                inputLabel: 'Numéro de facture',
                inputPlaceholder: 'Saisir votre numéro de facture',
                linkInfoLabel: 'Où la trouver ?',
                errorRequiredTenNumber: 'Le champ doit contenir 12 chiffres'
            },
            newEmailInput: {
                info: 'Indiquez avec quelle adresse vous allez maintenant vous identifier pour accéder à votre espace client {brand}.',
                newEmailField: {
                    label: 'Nouvelle adresse email',
                    placeholder: 'Saisir votre nouvelle adresse email'
                },
                newEmailConfirmField: {
                    label: 'Confirmer votre email',
                    placeholder: 'Confirmer votre nouvelle adresse email'
                }
            },
            sendingEmail: {
                info_1: 'Vous allez recevoir dans quelques instants un email à l’adresse',
                info_2: 'Cliquez sur le lien contenu dans cet email afin de finaliser la création de votre espace client {brand}.',
                info_3: 'Ce lien est actif 24h.',
                retry_1: 'Vous n’avez pas reçu d’email ?',
                retry_2: 'Renvoyer le lien'
            }
        }
    },
    updateEmailSecondStepScreen: {
        sessionError: 'Oups ! Votre session est expirée, veuillez recommencez la procédure.',
        loaderTitle: 'Modification de mon adresse mail',
        loaderMessage: 'Finalisation en cours. Veuillez patienter ... ',
        successCardTitle: 'Merci !',
        successCardContent: 'Votre adresse mail a été modifiée avec succès.',
        sucessCardBackButtonLabel: 'Revenir à la connexion'
    },
    navigations: {
        login: {
            label: 'Connexion',
            uri: 'connexion'
        },
        createAccountFirstSteps: {
            label: 'Création de compte',
            uri: 'creation-compte'
        },
        createAccountThirdStep: {
            label: 'Création de compte',
            uri: 'EspacePublic/Inscription.aspx'
        },
        moveIn: {
            label: "Je m'abonne",
            uri: 'abonnement'
        },
        cclAccess: {
            label: "Tentative d'accès ccl",
            uri: 'ccl-access'
        },
        forgetPassword: {
            label: 'Mot de passe oublié',
            uri: 'mot-de-passe-oublie'
        },
        updateEmailValidation: {
            label: '',
            uri: 'EspacePublic/FinaliserIdentifiant.aspx'
        },
        home: {
            label: 'Accueil',
            uri: 'accueil'
        },
        myContract: {
            label: 'Mon contrat',
            uri: 'mon-contrat'
        },
        myProfile: {
            label: 'Mon profil',
            uri: 'mon-profil'
        },
        myPaiements: {
            label: 'Mes paiements',
            uri: 'mes-paiements'
        },
        myConsumption: {
            label: 'Ma consommation',
            uri: 'ma-consommation'
        },
        myExchanges: {
            label: 'Mes échanges',
            uri: 'mes-échanges'
        },
        helpAndContacts: {
            label: 'Aide & contacts',
            uri: 'aide-et-contacts'
        },
        cgu: {
            label: 'CGU',
            uri: 'condition-générale-de-vente'
        },
        userData: {
            label: 'Données personnelles',
            uri: 'données-personnelles'
        },
        legalMentions: {
            label: 'Mentions légales',
            uri: 'mentions-légales'
        },
        contactUs: {
            label: 'Contactez-nous',
            uri: 'contactez-nous'
        },
        paymentReturn: {
            label: 'Retour du paiement',
            uri: 'retour-paiement'
        },
        updateEmailByBillingOrIban: {
            label: 'Modifier mon adresse email',
            uri: 'modifier-mon-adresse-email'
        },
        mobileApp: {
            home: 'Accueil',
            contract: 'Contrat',
            invoices: 'Paiements',
            consumptions: 'Conso',
            exchanges: 'Échanges'
        },
        deliveryPointRequestsTracking: {
            label: 'Suivi de ma Demande de Branchement',
            uri: 'suivi-branchement'
        },
        contactEmailValidation: {
            label: 'Validation de Contact',
            uri: 'EspacePublic/validation-email-de-contact'
        },
        contractCancelation: {
            label: 'Résiliation de contrat',
            uri: 'resiliation-contract'
        }
    },
    forms: {
        addContract: {
            clientReference: {
                placeholder: 'Référence à 10 chiffres',
                label: 'Référence client'
            },
            clientName: {
                oldPlaceholder: 'Votre nom client',
                placeholder: 'Dupont Jacques',
                oldLabel: 'Nom client',
                label: 'Nom et prénom du client (figurant sur la facture)'
            },
            contractName: {
                placeholder: 'Ex : DOMICILE',
                label: 'Nommer mon contrat'
            },
            errorTryAgainLater: 'Veuillez Réessayer plus tard.',
            referenceNameMatchingError: "Les données que vous avez saisies ne permettent pas d'identifier un compte. Merci de vérifier vos informations.",
            referenceUsedByAnotherAccountError: 'Cette référence est déjà liée à un autre compte.',
            alreadyIncludedReferenceError: 'Cette référence est déjà liée à ce compte.',
            userNotFound: "Une erreur liée à l''espace client est survenue, veuillez réessayer plus tard.",
            clientHasNoActiveOrRecentlyTerminatedContracts: "Cette référence ne peut être ajoutée à votre espace client car elle concerne des contrats résiliés depuis plus d'un an.",
            clientHasNoBillingAgreements: 'Cette référence ne peut être ajoutée à votre espace client car elle concerne des contrats en relève seule.',
            thanks: 'Merci !',
            requestAck: 'Votre demande a bien été prise en compte.',
            contractAdded: 'Votre nouveau contrat est désormais disponible dans votre espace client.',
            addContractTitle: 'AJOUTER UN CONTRAT',
            addContractButton: 'Ajouter le contrat',
            addContractButtonShort: 'Ajouter',
            addContractDesc: 'Vous possédez un autre contrat Saur,\nRajoutez le à votre espace client et visualisez\ntous vos contrats en toute simplicité.',
            defaultContractName: 'Domicile',
            addContractCancelButton: 'Annuler',
            closeErrorButton: 'Fermer',
            closeSuccessButton: 'Terminer',
            plzFillForm: 'Merci d’indiquer les informations situées en haut à droite de votre facture :'
        },
        updateAddress: {
            title: 'Modifier mon adresse de facturation',
            addressWord: 'Adresse',
            headerCurrentAddress: 'Adresse actuelle',
            formTitle: 'Nouvelle adresse de facturation',
            success: {
                title: 'Merci !',
                subtitle: 'La demande de modification de votre adresse de facturation a été prise en compte.',
                content: 'Votre espace client sera mis à jour sous 48 heures.'
            },
            error: {
                title: 'OUPS !',
                unknowError: "Votre demande de changement d'adresse a échoué. Veuillez réessayer ultérieurement.",
                wrongAddress: "Votre adresse n'est pas valide, veuillez recommencer la saisie."
            },
            address: {
                label: 'N° et voie',
                placeholder: 'Votre adresse'
            },
            address2: {
                label: 'Complément',
                placeholder: 'Optionnel'
            },
            address3: {
                label: 'Lieu dit',
                placeholder: 'Optionnel'
            },
            postalCode: {
                label: 'Code postal',
                placeholder: 'Votre code postal',
                errors: {
                    unvalid: "Le code postal n'est pas valide"
                }
            },
            city: {
                label: 'Ville',
                placeholder: 'Votre ville'
            },
            city2: {
                label: 'Cedex',
                placeholder: 'Optionnel'
            },
            country: {
                label: 'Pays',
                placeholder: 'Optionnel'
            }
        },
        ccl: {
            title: 'Dernière connexion client',
            email: {
                label: 'Adresse email client',
                placeholder: 'Adresse email client'
            },
            reference: {
                label: 'Référence client',
                placeholder: 'Référence client'
            },
            lastConnectionDate: 'Dernière connexion',
            creationDate: 'Date création de compte',
            error: {
                title: 'Client non trouvé'
            }
        },
        updatePhone: {
            title: 'Modifier mon numéro de téléphone',
            noCurrentNumber: 'Aucun numéro renseigné',
            headerCurrentPhone: 'Numéro actuel',
            formTitle: 'Nouveau numéro de téléphone',
            success: {
                title: 'Merci !',
                subtitle: 'La demande de modification de votre numéro de téléphone a bien été prise en compte.',
                content: 'Votre espace client sera mis à jour sous 48 heures.'
            },
            error: {
                title: 'OUPS !',
                unknowError: 'Votre demande de changement de numéro de téléphone a échoué. Veuillez réessayer ultérieurement.'
            },
            phone: {
                label: 'Numéro de téléphone portable',
                placeholder: 'Votre nouveau numéro de téléphone portable'
            }
        },
        updateEmail: {
            noCurrentEmail: 'Aucun email renseigné',
            title: 'Modifier mon adresse mail',
            headerCurrentPhone: 'Adresse mail actuelle',
            formTitle: 'Nouvelle adresse mail',
            success: {
                title: 'Merci !',
                subtitle: 'La demande de modification de votre adresse mail a été prise en compte',
                content: 'Un mail vient d’être envoyé à votre nouvelle adresse. Merci de cliquer sur le lien afin de confirmer la modification.'
            },
            error: {
                title: 'OUPS !',
                unknowError: "Votre demande de changement d'adresse mail a échoué. Veuillez réessayer ultérieurement."
            },
            email: {
                label: 'Nouvelle adresse mail',
                placeholder: 'Mon adresse mail'
            },
            emailConfirm: {
                label: 'Confirmer adresse mail',
                placeholder: 'Mon adresse mail',
                errors: {
                    notEqual: 'Les emails ne correspondent pas'
                }
            }
        },
        updateIban: {
            noCurrentIban: 'Aucun IBAN renseigné',
            title: 'Modifier mes coordonnées bancaires',
            headerCurrentIbanContract: 'IBAN actuel',
            formTitle: 'Nouvel IBAN',
            contractLabel: 'Mon contrat :',
            success: {
                title: 'Merci !',
                subtitle: 'Votre demande de changement d’IBAN sera prise en compte prochainement.',
                content: 'Et bientôt disponible dans votre espace client.'
            },
            error: {
                title: 'OUPS !',
                unknowError: "Votre demande de changement d'IBAN a échoué. Veuillez réessayer ultérieurement."
            },
            iban: {
                label: 'IBAN',
                placeholder: 'Votre IBAN'
            }
        },
        updatePassword: {
            title: 'Première connexion',
            titleIndicator: 'au nouvel espace client {brand}',
            subtitle: 'Votre mot de passe actuel n’est pas suffisamment sécurisé. Veuillez le modifier pour accéder à votre espace client.',
            oldUser: {
                title: 'Merci de mettre à jour votre mot de passe',
                subtitle: 'Afin de garantir la sécurité de votre espace client, nous mettons à jour nos outils de gestion des mots de passe. Merci de saisir un nouveau mot de passe pour accéder à votre espace.'
            },
            currentPassword: {
                label: 'Mot de passe actuel',
                placeholder: 'Mon mot de passe actuel'
            },
            newPassword: {
                label: 'Nouveau mot de passe',
                placeholder: 'Mon nouveau mot de passe',
                passwordIndication: 'Le mot de passe doit contenir au moins 8 caractères dont :',
                passwordIndicationSubtitle: '1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial'
            },
            confirmNewPassword: {
                label: 'Confirmer nouveau mot de passe',
                placeholder: 'Mon nouveau mot de passe'
            }
        },
        email: {
            label: 'Identifiant',
            placeholder: 'Votre email'
        },
        password: {
            label: 'Mot de passe',
            placeholder: 'Votre mot de passe'
        },
        iban: {
            label: 'Indiquez votre IBAN',
            placeholder: 'FR14 2234 8973 8872 9823 2872 088',
            error: "Le format de l'IBAN n'est pas correct"
        },
        numberOfPeople: {
            label: 'Indiquez le nombre de personnes vivant dans votre foyer',
            placeholder: 'Choisir',
            error: 'Ce champ est obligatoire'
        },
        withdrawalDate: {
            label: 'Choisissez votre jour de prélèvement mensuel',
            placeholder: 'Choisir',
            error: 'Ce champ est obligatoire'
        },
        errors: {
            meterIdentifierInvalid: "Votre numéro de compteur n'est pas valide",
            errorCounterSerialSize: 'Votre numéro de compteur doit comporter 11 caractères',
            phoneNotValid: "Le numéro de téléphone saisi n'est pas valide",
            phoneNotMobile: "Le numéro de téléphone saisi n'est pas un numéro de téléphone portable",
            landlineNumberError: "Le numéro de téléphone saisi n'est pas un numéro de téléphone fixe",
            emptyField: 'Un des deux champs est requis',
            emptyRequiredField: 'Ce champ est requis',
            emailBadFormat: 'Le format du mail est incorrect : les caractères spéciaux (tels que les accents) ne sont pas acceptés. De plus, votre email ne doit pas commencer par un point.',
            emailBadLength: "L'adresse mail saisie est trop longue.",
            newPasswordNotSame: "La confirmation n'est pas identique",
            passwordSecurityFailure: 'Le mot de passe doit contenir au moins 3 des 4 caractéristiques suivantes : 1 majuscule, 1 minuscule, 1 chiffre, 1 caractère spécial',
            passwordSecurityFailureTwo: 'Votre mot de passe ne respecte pas les règles de sécurité',
            wrongCurrentPassword: 'Le mot de passe actuel est erroné',
            emailAlreadyExistError: 'Cette adresse email est utilisée par un autre compte',
            contractNameFormatError: "Le format du nom de votre contrat n'est pas correct",
            noAdressInfo: 'Aucune adresse renseignée',
            amountToSmall: 'Le montant du prélèvement ne peut pas être inférieur à {amount}€',
            amountToHigh: 'Le montant saisi ne peut pas dépasser 300€',
            amountParamToHigh: 'Le montant saisi ne peut pas être supérieur à {amount}€',
            amountToHighWarning: 'Attention : mensualité importante',
            amountEnteredTooHigh: 'Attention, le montant saisi est supérieur à notre estimation : cela pourrait entrainer une régularisation à la fin de l’année.',
            amountEnteredTooSmall: 'Attention, le montant saisi est inférieur à notre estimation : cela pourrait entrainer une régularisation à la fin de l’année',
            onlyDigit: 'Le champ doit contenir que des chiffres',
            nameBadLength: 'La saisie est trop longue.',
            fileSizeLimit: 'La taille de la pièce jointe dépasse la limite autorisée de 10MB.',
            UserNot18OrOlder: "Vous devez avoir 18 ans ou plus pour être titulaire d'un contrat.",
            UserOlderThan100: "La date de naissance saisie n'est pas cohérente.",
            fileType: "Le format de la pièce jointe n'est pas accepté.",
            invalidEntryDate: "La date d'entrée au logement n'est pas valide.",
            matchingConfirmationFailure: "La confirmation n'est pas identique",
            useSameEmail: 'Merci de saisir un e-mail différent de celui du titulaire',
            notRoundedToNearestHalfEuro: 'Le montant du prélèvement doit être au demi euro près, par exemple {amount}€'
        },
        referenceClient: {
            placeholder: '0000000000'
        },
        userName: {
            oldPlaceholder: 'Dupont',
            placeholder: 'Dupont Jacques'
        },
        createAccountEmail: {
            label: 'Mon email',
            placeholder: 'jacques.dupont@email.com',
            formatError: "Le format du mail n'est pas correct",
            emptyError: 'Ce champ est requis'
        },
        createAccountEmailValidation: {
            label: 'Confirmer mon email',
            placeholder: 'jacques.dupont@email.com',
            notEqualError: 'Les emails ne correspondent pas',
            emptyError: 'Ce champ est requis'
        },
        createAccountAcceptCGU: {
            accept: "J'accepte ",
            CGUFull: "les Conditions Générales d'Utilisation ",
            CGUAbreviation: '(CGU)',
            error: 'Ce champ est requis'
        },
        createAccountAcceptSaurContact: {
            label: 'J’accepte de recevoir par email des communications et actualités relatives aux services de l’entreprise'
        },
        updateContractName: {
            placeholder: 'Votre nouveau nom de contrat',
            success: {
                title: 'Merci !',
                subtitle: 'La demande de modification du nom de votre contrat a bien été prise en compte.',
                content: 'Votre espace client a été mis à jour.'
            },
            error: {
                title: 'OUPS !',
                unknowError: 'Votre demande de changement de nom de votre contrat a échoué. Veuillez réessayer ultérieurement.'
            }
        }
    },
    api: {
        admin: {
            errors: {
                unknownError: 'Le site est actuellement en maintenance. Veuillez réessayer ultérieurement'
            }
        },
        auth: {
            errors: {
                unknownError: 'Une erreur inconnue est survenue',
                wrongIdentifiers: 'Votre identifiant et/ou mot de passe est erroné',
                wrongPassword: 'Votre mot de passe actuel est erroné',
                identicPassword: "Vous ne pouvez pas saisir un nouveau mot de passe identique à l'actuel",
                invalidToken: 'Le token est invalide',
                invalidDataToSend: 'Les informations saisies sont incorrectes',
                unsuccessfulAction: "Cette action n'a pas pu aboutir",
                contractTerminated: 'Votre compte est expiré',
                alreadyValidated: 'La validation est déjà faite'
            }
        }
    },
    invoice: {
        errorApi: {
            documentNotFound: 'Votre facture sera disponible dans un délai de 48h',
            documentExtensionNotSupported: 'Ce type de facture n’est pas consultable depuis votre espace connecté'
        },
        mySituation: {
            title: 'Ma situation',
            subTitle: 'Solde de votre compte au {date}',
            payButtonLabel: 'Régler mon solde',
            minimumLimitError: 'Votre solde est inférieur au minimum requis pour le paiement par carte bancaire. Ce solde sera donc à régler avec votre prochaine facture',
            terminatedContractLimitError: 'Votre solde est inférieur au minimum requis pour le paiement par carte bancaire. Merci de régler votre solde par tout autre moyen de paiement'
        },
        titleCardEvent: 'Ma dernière facture',
        Screenheader: {
            myPayments: 'Mes paiements',
            debits: 'Prélèvements',
            invoices: 'Factures',
            myservices: 'Mes services'
        },
        ScreenLastInvoice: {
            cardTitle: 'Ma dernière facture',
            invoiceNumber: 'Facture n°',
            invoiceReference: 'Référence n°',
            issuedon: 'Émise le',
            payedon: 'Réglée le',
            payed: 'Réglée',
            toSettle: 'À régler avant le',
            consult: 'Consulter',
            Download: 'Télécharger',
            payeInvoice: 'Payer ma facture',
            cardHistoryTitle: 'Mes factures',
            history: 'Historique de mes factures',
            next: 'Voir la suite',
            prev: 'Réduire',
            invoice: 'Facture',
            relaunch: 'Lettre de relance',
            formalNotice: 'Mise en demeure'
        },
        ScreenAdvice: {
            adviceTitle: 'vous conseille',
            adviceSubtitle: 'passez gratuitement au prélèvement !',
            adviceSubtitle2: 'Passez gratuitement \nau prélèvement mensuel',
            freedom: "Libérez-vous l'esprit",
            rythme: 'Payez à votre rythme',
            asArises: "Payer au fil de l'eau",
            keepInvoices: 'Ne perdez plus vos factures !',
            buttonText: 'Passer au prélèvement',
            buttonTextMonthly: 'Passer à la mensualisation'
        },
        ScreenServices: {
            title: 'Mes Services'
        },
        ServicesDebit: {
            title: 'Prélèvement',
            subtitle: 'Activé',
            disabledSubtitle: 'Désactivé'
        },
        downloadScreen: {
            back: 'Retour',
            downloadDone: 'Facture téléchargée avec succès !',
            downloadProofDone: "L'attestation de titulaire de contrat est téléchargée avec succès !",
            permission: 'Permission refusée',
            error: 'Erreur de téléchargement',
            pdf: '.pdf'
        },
        ServicesEBill: {
            title: 'Facture électronique',
            activatedSince: 'Activée',
            inactifService: 'Service inactif',
            activate: 'Activer',
            activateOption: {
                activateEBill: 'Activer la facture électronique',
                chooseElectronicInvoice: 'Passez à la facture électronique',
                chooseElectronicInvoice2: 'Passez à la facture\nélectronique',
                adviceOne: 'Vous êtes averti par mail pour toute nouvelle facture',
                adviceTwo: 'Vous y accédez en ligne 24h/24 7j/7',
                adviceThree: 'Vous contribuez à réduire la consommation de ressources naturelles',
                activateOptionForFree: 'Activer l’option gratuitement',
                notInterested: 'Je ne suis pas intéressé(e)',
                validateBtnLabel: 'Valider ma souscription'
            },
            activateDescription: {
                titleItsFast: "C'est rapide",
                descriptionItsFast: 'Vous êtes averti par email de la mise à disposition de toute nouvelle facture',
                titleItsEasy: "C'est facile",
                descriptionItsEasy: 'Vous accédez en ligne à vos factures 24h/24 et 7j/7 dans votre espace client',
                titleItsConvenient: "C'est pratique",
                descriptionItsConvenient: 'Vos factures sont conservées durant 5 ans dans votre espace client',
                titleItsGreen: "C'est écologique",
                descriptionItsGreen: 'Vous contribuez à réduire la consommation de ressources naturelles',
                titleItsFree: "C'est gratuit",
                descriptionItsFree: 'Vous pouvez annuler à tout moment'
            },
            activateOptionSuccess: {
                title: 'Votre demande a bien été prise en compte !',
                amountCharged: 'Montant prélevé',
                frequency: 'mois',
                directDebitActivation: 'Activation du prélèvement mensuel',
                electronicInvoiceActivation: 'Activation de la facture électronique',
                descriptionPartOne: 'Vous recevrez prochainement un mandat SEPA à nous retourner dans les plus brefs délais.',
                descriptionPartTwo: 'Un mail vous sera envoyé quand un conseiller clientèle aura pris en compte votre demande',
                goToPaymentDashboardBtnLabel: 'Accéder à mon espace « paiements »',
                electronicInvoiceSoonReady: 'Vos factures électroniques seront bientôt disponibles dans votre espace',
                calendarSoonReady: 'Votre calendrier de paiement sera consultable sous 24h depuis votre espace client rubrique mes paiements.',
                signSepaMadate: 'Signer mon mandat SEPA'
            },
            terminateEbillService: {
                terminateOption: 'Désactiver',
                terminateEbillModal: {
                    title: 'Désactiver la facture électronique',
                    content1: 'Vous êtes sur le point de désactiver l’option de facture électronique.',
                    content2: 'Une fois désactivée, vous n’aurez plus accès à l’historique de vos factures sur votre espace client. Seule votre dernière facture sera visible au format duplicata.',
                    content3: 'Vous pouvez à tout moment réactiver cette option.',
                    terminateCta: 'Désactiver',
                    cancelTerminationLink: 'Conserver la facture électronique',
                    terminateEbillServiceSuccess: {
                        title: 'Facture électronique désactivée',
                        content: 'Vous pouvez à tout moment repasser à la facture électronique en activant le service.',
                        terminateCta: 'Terminer'
                    }
                }
            }
        },
        HowItWorks: {
            title: 'Comment ça marche ?',
            stepOneCompleteYourInfoTitle: 'Complétez vos informations',
            stepOneCompleteYourInfoDesc: 'IBAN et estimation de consommation',
            stepOneCompleteYourInfoV2DescEstimatbale: 'IBAN et montant de la mensualité',
            stepOneCompleteYourInfoV2DescNotEstimatbale: 'Saisissez votre IBAN',
            stepTwoChoseDateTitle: 'Choisissez votre jour de prélèvement mensuel',
            stepTwoChoseDateDesc: 'Vous serez prélevé le jour choisi tous les mois',
            stepThreeSendSepaTitle: 'Retournez-nous votre mandat SEPA',
            stepThreeSendSepaDesc: 'Par courrier ou par email',
            stepThreeDesc: 'Votre demande sera traitée par un conseiller clientèle',
            stepFourTitle: 'Enregistrement sous 24h',
            stepFourDesc: 'Dès réception de votre mandat signé',
            warningTitle: 'INFORMATION',
            warningMessage: 'en période de facturation, le premier prélèvement n’interviendra qu’après émission de votre prochaine facture',
            warningMessageFull: 'INFORMATION : en période de facturation, le premier prélèvement n’interviendra qu’après émission de votre prochaine facture',
            subscriptionBtnLabel: 'Souscrire au prélèvement',
            subscriptionBtnLabelV2: 'Souscrire à la mensualisation'
        },
        SubscribeToDebit: {
            title: 'Souscrire au prélèvement',
            titleV2: 'Souscrire au prélèvement mensuel',
            yourIban: 'Indiquez votre IBAN',
            correctIfIncorrect: 'À corriger si incorrect',
            numberOfPeopleTitle: 'Indiquez le nombre de personnes vivant dans votre foyer',
            chooseDebitDateTitle: 'Choisissez votre jour de prélèvement mensuel',
            estimatedInvoiceLabel: 'Estimation de votre facture',
            estimatedInvoiceDesc: 'Ce montant indicatif sera ajusté en fonction du prix réel appliqué sur votre commune. Un récapitulatif des mensualités à venir vous sera adressé par le Service Clientèle.',
            chooseDebitPlaceholder: 'Choisir',
            validateMySubscription: 'Valider ma souscription',
            chooseDebitDescPartOne: 'Vous serez prélevé chaque',
            chooseDebitDescPartTwo: 'du mois',
            estimatedAmountLabel: 'Estimation du montant de ma facturation',
            estimatedAmountLabelMonthly: 'Estimation du montant de ma mensualité',
            paymentPerYear: '/an',
            paymentPerSemester: '/semestre',
            paymentPerMonth: '/mois',
            estimatedNoticeAmountLabel: '* l’estimation est basée sur la consommation facturée l’année dernière.',
            estimatedNoticeAmountSemesterLabel: '* l’estimation est basée sur la consommation facturée le semestre dernier.',
            myIbanLabel: 'Mon IBAN',
            myIbanDescription: 'Je peux le saisir ou le mettre à jour',
            monthlyPaymentLabel: 'Je souhaite être prélevé de',
            monthlyPaymentLabelNoEstimate: 'Je souhaite être prélevé tous les',
            monthlyPaymentDescription: 'Je peux modifier le montant de la mensualité proposée',
            debitDaysLabelPart1: 'tous les',
            debitDaysLabelPart2: 'du mois',
            chooseDebitPlaceholderV2: '1-15'
        },
        SubscribeToDebitAtMaturity: {
            title: 'Souscrire au prélèvement à échéance',
            proposition: 'Vous préférez être prélevé 15 jours après l’édition de votre facture ?',
            chooseQuestion: 'Choisissez le',
            directDebitMaturity: 'prélèvement à échéance',
            directDebitMaturity2: 'Prélèvement à échéance',
            requestRegistered: 'Votre demande a bien été prise en compte.',
            debitedInformation: 'Vous serez prélevé 15 jours après l’émission de votre facture.',
            nextDebit: 'Prochaine facture',
            goToPayments: 'Découvrir mon nouvel espace « paiements »',
            confirmationActivation: 'Activation du prélèvement à échéance'
        }
    },
    updateAppModal: {
        title: 'UNE MINUTE !',
        info: 'Une nouvelle version de l’application est disponible.',
        instruction: 'Veuillez la télécharger pour continuer sur l’application.',
        btnActionLabel: 'Télécharger la mise à jour'
    },
    maintenanceScreen: {
        title: 'OUPS...',
        info: "Maintenance de l'application",
        instruction: 'Vous pourrez très prochainement vous reconnecter. Veuillez nous excuser pour ce contre-temps',
        btnActionLabel: "Fermer l'application"
    },
    consumption: {
        from: 'De',
        to: 'à',
        fromDate: 'Du',
        first: 'er',
        second: 'ème',
        thrid: 'ème',
        fourthAndMore: 'ème',
        toDate: 'au',
        nextBtnAlt: 'Suivant',
        prevBtnAlt: 'Précédent',
        backBtnAlt: 'Retour',
        onHover: 'le',
        year: 'Année',
        month: 'Mois',
        week: 'Semaine',
        title: 'MA CONSOMMATION',
        tipsBtnLabel: '{brand} vous conseille',
        currentYearMessage: "Sur l'année",
        currentMonthMessage: 'Sur le mois de',
        currentWeekMessage: ' Sur la semaine ',
        yearsIntervalMessageDebut: 'sur les',
        yearsIntervalMessageEnd: 'dernières années',
        oneYearIntervalMessage: 'sur la dernière année',
        loading: 'Chargement des données ...',
        apiError: 'Erreur de chargement de votre consommation.',
        noDataToDisplay: 'Pas encore de relevé de votre consommation.',
        details: 'Voir détails',
        exportConsumption: 'Exporter les données de la famille',
        estimateConsumptionMessage: "Le module télérelève d'un de vos branchements dysfonctionne, les consommations sont donc estimées",
        real: 'Réelle',
        estimate: 'Estimée',
        global: 'Globale'
    },
    payment: {
        nextPayment: 'Prochain prélèvement',
        seeDetailsNextPayment: 'Voir les détails de mon prochain prélèvement (nouvel onglet)',
        paymentSuccess: 'Votre transaction a bien été enregistrée. Votre compte sur votre Espace Client sera mis à jour dans un délai de 48 heures.',
        paymentCancelled: 'Votre demande de paiement a bien été annulée.',
        paymentRefused: "Votre paiement n'est pas accepté par votre établissement financier. Nous regrettons de ne pas pouvoir donner une suite favorable à votre demande.",
        errors: {
            noPayment: 'Le paiement a déjà été effectué. Votre espace client sera mis à jour dans un délai de 48 heures.',
            clientCutOff: 'La situation de votre compte ne permet pas de payer directement depuis notre site.',
            contactUs: ' Veuillez contacter notre service client.'
        },
        paymentSuccessMobile: 'Votre paiement a été effectué avec succès',
        paymentSuccessSubtitle: 'Votre solde est réglé !',
        paymentSuccessMailMessage: 'Un mail de confirmation vous sera envoyé',
        paymentSuccessBackButton: 'Revenir à mes factures',
        paymentHistory: {
            cardFull: {
                cardFullTitle: 'Mon Prochain Prélèvement',
                cardFullDatePicked: 'Prélevé le ',
                carfFullBtnLabel: 'Modifier mon prélèvement'
            },
            list: {
                listTitle: 'Mes Prélèvements',
                listSubTitle: 'Calendrier des mensualisations',
                oldDebit: 'Prélevé le ',
                nextDebit: 'Prochain prélèvement le ',
                nextDebit2: 'Prochain prélèvement\nle ',
                futurDebit: 'Prélèvement le '
            },
            updateDebitOptionModal: {
                inputsForm: {
                    label_1: 'Je souhaite être prélevé de',
                    label_2: 'tous les',
                    label_3: 'du mois',
                    AmountPlaceholder: '35€',
                    dayPlaceholder: '1 - 15'
                },
                successPage: {
                    title: 'Prélèvement modifié !',
                    willBeDisplayedShortly: 'Votre demande a bien été prise en compte et sera visible très prochainement dans votre espace client.',
                    debitDateDescription: 'tous les',
                    debitAmountDescription: 'Vous serez prélevé de',
                    debitUpdateMonthOnly: 'de chaque mois',
                    debitUpdateMonth: 'de chaque mois à partir de',
                    desc: 'Votre demande a bien été prise en compte et sera visible sous 72h dans votre espace client'
                }
            }
        }
    },
    exchanges: {
        title: 'Mes échanges',
        noExchangeTitle: 'Vous n’avez pas encore\nd’échanges avec Saur',
        noExchangeMessage: 'Retrouvez dans cette section toutes vos demandes et réponses apportées par Saur.',
        sectionWorkOrderTitle: 'SUIVI DE MES INTERVENTIONS',
        requestSection: {
            requests: 'Demandes',
            title: 'Mes demandes',
            historicLabel: "Voir l'historique de mes demandes",
            actionLabel: 'Nouvelle demande',
            emptyRequest: 'Pas de demandes en cours',
            showRequestsPage: {
                informationTooltip: 'Nous affichons les demandes des 3 dernières années uniquement',
                processingClaimsLink: 'Consulter les engagements de traitement des demandes',
                showMoreRquests: 'Afficher plus de demandes',
                since: 'Depuis le',
                status: {
                    Received: 'Reçue',
                    Closed: 'Clôturée',
                    InProgress: 'En cours de traitement'
                }
            }
        },
        interventionSection: {
            interventions: 'Interventions',
            title: 'Les interventions à mon domicile',
            historicLabel: "Voir l'historique des interventions",
            emptyIntervention: 'Aucune intervention réalisée ou en cours de planification sur votre branchement'
        },
        alerts: 'Mes alertes',
        configTitle: 'Toutes les alertes',
        alertsTypes: 'Paramétrage des alertes',
        lastAlerts: 'Mes dernières alertes',
        successMessage: 'Votre demande est prise en compte',
        failureMessage: "Votre demande n'est pas prise en compte",
        informativeMessage: 'Bientôt ici de nouvelles fonctionnalités : \n -La détection d’une fuite résiduelle à faible débit \n -La surveillance de votre consommation durant vos absences \n -La notification de vos alertes de surconsommation à plusieurs destinataires de votre choix',
        noAlerts: "Vous n'avez aucune alerte pour le moment",
        overconsumingAlertsSection: {
            alerts: 'Alertes',
            title: 'Mes alertes de surconsommation',
            emptyAlert: "Pas d'alertes de surconsommation",
            timeRange: 'Du {start} au {end}',
            timeRangeStartDayOnly: 'Depuis le {start}',
            alertBoxTitle: 'Consommation anormalement élevée : plus de {qty}L par jour pendant au moins {duration} jour(s) consécutif(s).',
            emailNotification: 'Notification par email à {email}',
            phoneNotification: 'Notification par SMS au {phone}',
            emptyNotification: 'Pas de notifications',
            overConsumptionAlert: 'Alerte de surconsommation',
            overConsumptionAlertThreshold: 'Seuil de surconsommation',
            liter: 'litres',
            edit: 'modifier',
            chooseThresholdLabel: 'Choisir un seuil',
            editThreshold: 'Modifier le seuil',
            alwaysOn: 'Toujours activée',
            alertDetail: "Détail de l'alerte",
            alertDetailMessage: 'Vous serez alerté si votre consommation a dépassé le seuil paramétré ici',
            alertDetailMessageApp: 'Vous serez alerté si votre consommation a dépassé le seuil paramétré ici par jour pendant {duration} jour(s)',
            duration: 'durée de surconsommation',
            day: 'jour(s)',
            validate: 'Valider',
            unauthorizedVolumeThreshold: 'Votre seuil a déjà été modifié par un conseiller clientèle, merci de contacter votre conseiller clientèle',
            type: 'Surconsommation'
        },
        residualLeakAlertsSection: {
            alertName: 'Alerte de fuite résiduelle',
            alertMessage: 'Activez l’alerte fuite résiduelle et recevez une notification par e-mail et/ou SMS si une consommation d’eau est relevée sur 24 heures en continu',
            residualLeakInformation: 'Consommation en continu sur 24h',
            information: 'infos',
            activated: 'Activée',
            disabled: 'Désactivée',
            type: 'Fuite résiduelle'
        },
        traquilityAlertSection: {
            alertName: 'Alerte de tranquillité',
            alertMessage: 'Activez l’alerte tranquillité et recevez une notification par e-mail/SMS lorsqu’une consommation d’eau est détectée en votre absence',
            tranquilityInformation: 'Consommation de {value} litres détectée',
            tranquilityAlertMessage: "Définir une période d'absence et être alerté si j'ai une consommation",
            activated: 'Activée',
            disabled: 'Désactivée',
            type: 'Tranquillité',
            slotDateMessage: 'Le {date}'
        },
        interventionItemSection: {
            planInterButton: 'Planifier',
            modifyInterButton: 'Modifier',
            cancelInterButton: 'Annuler',
            interToBePlanned: 'Intervention à planifier',
            EditPopupSection: {
                title: 'Modifier ou annuler mon rendez-vous',
                message: 'Ces fonctionnalités ne sont pas encore disponibles sur votre espace client. Merci de contacter votre service client par téléphone afin de modifier ou annuler votre rendez-vous.'
            }
        },
        interventionRDVSection: {
            Address: 'Lieu',
            MeterID: 'Numéro de compteur',
            Slot: 'Créneau',
            Info: 'Infos RDV',
            infoRdv1Part1: 'Un agent se présentera sur le lieu de l’intervention durant la plage horaire sélectionnée.',
            infoRdv1Part2: 'L’agent ne vous appellera pas pour confirmer sa venue.',
            infoRdv2: 'En cas d’indisponibilité, vous avez jusqu’à la veille la possibilité de modifier ou d’annuler le rendez-vous pris. En cas d’absence de votre part, si le rendez-vous n’a pas été annulé par vos soins, le déplacement de l’intervention vous sera facturé.',
            LangDate: 'fr-FR',
            appointmentReason: 'Motif du rendez-vous',
            phoneNumber: 'Numéro de contact',
            moreInfo: "Complément d'informations"
        },
        appointment: {
            title: 'Planifier une intervention',
            interventionType: {
                MeterRenew: 'Renouvellement de compteur'
            },
            stepper: {
                InterventionType: 'Motif',
                AppointmentDate: 'Créneau',
                ClientInformation: 'Informations',
                Recap: 'Récapitulatif'
            },
            intervetionTypeStep: {
                interventionType: {
                    label: "Motif de l'intervention",
                    placeholder: "Choisissez un type d'intervention"
                }
            },
            informationStep: {
                phoneLabel1: 'Veuillez vérifier votre numéro de téléphone portable de contact.',
                phoneLabel2: 'Le numéro de téléphone saisi sera mis à jour sur votre profil client.',
                extraInformationLabel: 'Si besoin, veuillez saisir un complément d’informations pour l’agent.',
                extraInformationPlaceholder: 'Ex: autre numéro de téléphone pour cette intervention',
                phonePlaceholder: 'Mon numéro de téléphone mobile'
            },
            interventionCalendarStep: {
                noSlotsFoundMsg: 'Aucun créneau n’est disponible pour ces 15 prochains jours. Veuillez réessayer ultérieurement'
            },
            appointmentPickStep: {
                lastAvailableDay: 'Les dates suivantes ne sont pas encore ouvertes à la planification.'
            },
            success: {
                thankYou: 'MERCI !',
                rdvSuccess: 'Votre rendez-vous est programmé.',
                successPart1: 'En cas d’indisponibilité, vous avez jusqu’à la veille la possibilité de modifier ou d’annuler le rendez-vous pris dans le suivi des interventions dans la rubrique « Mes échanges ».',
                successPart2: 'En cas d’absence de votre part, si le rendez-vous n’a pas été annulé par vos soins, le déplacement de l’intervention vous sera facturé.',
                closeButton: 'Terminer'
            },
            failure: {
                closeButton: 'Fermer',
                errorMessage: "UNE ERREUR S'EST PRODUITE",
                errorDescriptionMessage: 'Un problème technique a empêché la validation de votre demande.'
            },
            unauthorizedEditOrCancel: {
                title: 'Modifier ou annuler mon rendez-vous impossible',
                description: "Vous ne pouvez plus modifier ou annuler votre rendez-vous moins de 24h avant l'intervention. Veuillez contacter votre service client."
            },
            cancel: {
                recap: {
                    title: 'Annuler mon rendez-vous',
                    message1: "Vous êtes sur le point d'annuler l'intervention planifiée suivante:",
                    message2: 'Une fois annulé, il vous faudra à nouveau cliquer sur le bouton " planifier " afin de pouvoir prendre rendez-vous pour une nouvelle intervention.',
                    confirmButton: 'Annuler mon intervention'
                },
                success: {
                    title: 'Votre rendez-vous a bien été annulé.',
                    message1: 'Afin que votre intervention ait bien lieu, un nouveau rendez-vous doit impérativement être planifié.',
                    message2: 'Pour cela, il vous faudra à nouveau cliquer sur le bouton « planifier » afin de pouvoir prendre rendez-vous pour une nouvelle intervention.',
                    confirmButton: 'Terminer'
                }
            },
            conflict: "Nous sommes désolés, mais le créneau que vous aviez choisi n'est plus disponible. Merci d'en sélectionner un nouveau.",
            loadingSlots: 'Veuillez patienter, nous recherchons actuellement les créneaux disponibles ...',
            loadingBooking: 'Veuillez patienter pendant que nous validons votre prise de rendez-vous',
            nextBtnAlt: 'Suivant',
            prevBtnAlt: 'Précédent',
            validateBtnAlt: 'Valider'
        },
        multiRecipients: {
            title: 'QUI REÇOIT MES ALERTES ?',
            firstParagraph: 'Vous pouvez ici configurer les adresses mails qui recevront vos alertes. \n Vous pouvez aussi rajouter un numéro de téléphone.',
            secondParagraph: "Sans adresse supplémentaire renseignée seul le titulaire de l'espace client peut recevoir les alertes: {email}",
            titleAdressesForm: 'Adresses supplémentaires',
            titlePhoneForm: 'Envoi par SMS',
            submitForm: 'Valider les changements',
            phone: 'Numéro de téléphone',
            emailAdresse2: 'Adresse mail 1',
            emailAdresse3: 'Adresse mail 2',
            emailAdresse4: 'Adresse mail 3',
            titleSuccess: 'Vos adresses ont bien été mises à jour.',
            firstParagraphSuccess: 'Un message a été envoyé aux adresses et numéro renseignés.',
            secondParagraphSuccess: 'Une validation de leur part est nécessaire pour recevoir les alertes.',
            submitSuccess: 'Terminer',
            titleFailure: 'Impossible de changer l’adresse mail.',
            firstParagraphFailure: 'Vous ne pouvez plus modifier votre adresse mail.',
            secondParagraphFailure: 'Veuillez contacter votre service client.',
            submitFailure: 'Fermer',
            emailError: 'Vous avez déjà utilisé cette adresse email',
            validatedMessageTooltip: "Cette adresse est utilisée pour l'envoie des alertes",
            pendingMessageTooltip: 'Un mail a été envoyé à votre contact, il a 48h pour valider ce mail',
            expiredMessageTooltip: "Le mail n'a pas été validée pour le co-destinataire, merci de lui renvoyer ou de saisir une autre adresse",
            validatedMessage: 'Activé',
            pendingMessage: 'En attente de validation',
            expiredMessage: 'Non validée',
            informativeMessage: 'Les mails de validation seront envoyés dés votre validation des changements',
            titleSuccessWithAdresses: 'Vos adresses {emails} ont bien été mises à jour.',
            failedEmailMessage: "Nous n'avons pas réussi à envoyer le mail de validation à {contact}, une erreur inconnue est survenue. Merci de réessayer.",
            failedPhoneMessage: "Nous n'avons pas réussi à envoyer le SMS de validation à {contact}, une erreur inconnue est survenue. Merci de réessayer."
        },
        validateAlertContact: {
            titleSuccess: 'Vous avez été ajouté avec succès en tant que co-destinataire',
            firstParagraphSuccess: 'Merci pour votre validation.',
            titleFailure: 'Nous ne pouvons pas vous ajouter en tant que co-destinataire',
            firstParagraphFailure: 'Le lien que vous avez utilisé expire au bout de 48h.',
            secondParagraphFailure: 'Le demandeur a la possibilité de vous renvoyer une demande à travers son espace internet.',
            alreadyAddedAsCoReceiver: 'Vous avez déjà été ajouté en tant que co-destinataire',
            alertCoReceiver: 'Si une alerte se produit pour le demandeur, vous serez contacter en tant que co-destinataire.'
        }
    },
    articles: {
        title: '{brand} vous conseille',
        details: 'Voir plus'
    },
    HelpContactsScreen: {
        receptionCenter: "Point d'accueil",
        receptionCenterTitle: 'Nous rencontrer',
        receptionCenterDesc: "Retrouvez le point d'accueil {brand} qui vous est dédié ainsi que nos coordonnées téléphoniques",
        receptionRedirection: "Voir mon point d'accueil",
        makeArequestLink: 'Faire une demande',
        makeArequestCardTitle: 'NOUS CONTACTER',
        makeArequestCardDescription: 'Transmettez-nous vos demandes, nous répondrons à vos questions dans les meilleurs délais',
        SemMakeArequestCardDescription: "Contactez-nous par mail ou prenez directement rendez-vous avec un conseiller en point d'accueil ou par téléphone",
        eligibilityMessage: 'Votre dernière demande est en cours de traitement par votre conseiller clientèle'
    },
    userinformation: {
        UnknownAddress: "Mon adresse n'apparaît pas",
        myProfile: 'MON PROFIL',
        myContract: 'Mon contrat',
        email: 'Email',
        phone: 'Téléphone',
        billingAdress: 'Adresse de facturation',
        bankInformation: 'Coordonnées bancaires',
        newsletter: 'Newsletter',
        newsletterAgree: 'Je souhaite recevoir les communications de {brand} par',
        newsletterAgreeEmail: 'email',
        newsletterAgreeSms: 'sms',
        disconnect: 'Se déconnecter',
        expiredSession: {
            title: 'Session expirée',
            message: 'Vous avez été déconnecté car votre session a expiré.'
        },
        deleteAccountText: 'Vous ne souhaitez plus avoir accès à votre espace client {brand} ?',
        deleteAccountLink: 'Me désinscrire de l’espace client {brand}'
    },
    updateEmail: {
        screenTitle: 'Modifier mon adresse mail',
        currentEmail: 'Adresse mail actuelle',
        newEmail: 'Nouvelle adresse mail',
        confirmNewEmail: 'Confirmer adresse mail',
        yourEmailPlaceHolder: 'Votre email',
        register: 'Enregistrer',
        successThankYou: 'Merci !',
        successTitle: 'Votre demande à été prise en compte',
        successMessage: 'Un mail vient d’être envoyé à votre nouvelle adresse mail. Merci de cliquer sur le lien afin de confirmer la modification.',
        sucessFinish: 'Terminer'
    },
    updateIban: {
        screenTitle: 'Modifier mes coordonnées bancaires',
        invalidIban: "L'IBAN n'est pas valide. Veuillez vérifier votre saisie.",
        updateIsPending: 'Nous avons déjà reçu votre demande de changement d’IBAN : la mise à jour sera visible dans votre espace connecté sous 72 heures maximum.',
        myContract: 'Mon contrat',
        currentIban: 'IBAN actuel',
        newIban: 'Nouvel IBAN',
        yourIban: 'Votre IBAN',
        register: 'Enregistrer',
        successThankYou: 'merci!',
        successTitle: 'Votre numéro d’IBAN a été mis à jour',
        successMessage: 'Votre demande de changement d’IBAN sera prise en compte prochainement et bientôt disponible dans votre espace client.'
    },
    common: {
        serviceUnavailable: 'Le service est momentanément indisponible, veuillez réessayer dans 24h',
        errorGetData: 'Erreur de récupération de vos données',
        seeDetails: 'Voir détails',
        currency: '€',
        valid: 'Valider',
        cancel: 'Annuler',
        floatingPoint: ',',
        waterMeasuringUnit: 'm³',
        welcome: 'Bienvenue',
        copyRight: ' © {brand} Service Client - Tous droits réservés',
        clientArea: 'Espace client',
        goToProfile: 'Accéder à mon profil',
        noDataToBeDisplayed: 'Aucune donnée à afficher',
        save: 'Enregistrer',
        wrongFormat: "Le format n'est pas correct",
        wrongReferenceClientFormat: "La référence client soumise n'est pas valide",
        identificationDenied: "Nous n'avons pas réussi à vous identifier",
        update: 'Modifier',
        loadingFetchingData: 'Veuillez patienter ...',
        errorFetchingData: 'Une erreur est survenue, veuillez réessayer plus tard',
        errorLoading: 'Erreur de chargement',
        loading: 'Chargement',
        oups: 'Oups ...',
        ok: 'OK',
        at: 'au',
        and: 'et',
        between: 'entre',
        close: 'fermer',
        home: 'Domicile',
        wrongStatusAtCreation: 'Une erreur est survenue dans la création de votre espace client.\nNous vous remercions de prendre contact avec votre service clientèle en mentionnant le code erreur suivant: X01',
        wrongStatusAtAddition: 'Une erreur est survenue lors de votre ajout de référence client à votre espace.\nNous vous remercions de prendre contact avec votre service clientèle en mentionnant le code erreur suivant: X02',
        wafBlockingError: 'Une erreur liée à notre politique de sécurité est survenue.\nNous vous remercions de prendre contact avec votre service clientèle en mentionnant le code erreur suivant: X03',
        network502Error: 'Le service est momentanément indisponible (code 502), veuillez réessayer ultérieurement',
        network503Error: 'Le service est momentanément indisponible (code 503), veuillez réessayer ultérieurement',
        network504Error: 'Le service est momentanément indisponible (code 504), veuillez réessayer ultérieurement'
    },
    lastMeter: {
        title: 'Dernier relevé compteur'
    },
    contract: {
        myContracts: 'Mes contrats ',
        chooseContract: 'Sélectionner un contrat',
        contracts: 'Contrats',
        actions: {
            remove: 'Retirer',
            select: 'Choisir',
            cancel: 'Résilier',
            add: 'Ajouter',
            rename: 'Renommer',
            download: 'Télécharger',
            modify: 'Modifier'
        },
        deliveryInfos: {
            delivery: 'Branchement',
            deliveryType: 'Type',
            statedOn: 'Relevé du',
            techInfos: 'Informations Techniques',
            meterNumber: 'Numéro du compteur',
            diameter: 'Diamètre',
            brand: 'Marque',
            location: 'Emplacement',
            installationDate: 'Date de pose',
            chooseDelivery: 'Sélectionner un branchement'
        },
        contractInfos: {
            contractRefClient: 'Référence client',
            rename: 'Renommer',
            addContractButton: 'Ajouter un contrat',
            removeContractButton: 'Résilier un contrat',
            downloadContractButton: 'Télécharger une attestation',
            documentName: 'Attestation titulaire de contrat',
            contractNumberTitle: 'Numéro de contrat',
            contractStartDate: 'Débuté le',
            contractModifyButton: 'Modifier mon contrat',
            noContract: 'Aucun contrat disponible',
            renameContractModal: {
                title: 'Modifier le nom de mon contrat',
                currentContractName: 'Nom du contrat actuel',
                newContractName: 'Nouveau nom du contrat'
            }
        },
        multiContract: {
            selectContract: 'Sélectionner un contrat'
        },
        chooseContractModal: {
            title: 'Sélectionner un contrat',
            customerRef: 'Référence client {reference}',
            resiliatedAt: 'Résilié le {date}',
            delay: 'Votre espace client sera mis à jour sous 24 heures.',
            customerAccountRef: 'Référence compte client : ',
            contractIndex: 'Contrat {index}'
        },
        cancelContract: {
            title: 'Résilier un contrat',
            cancelMyContract: 'Résilier mon contrat',
            descModalTitle: 'Vous déménagez et vous souhaitez résilier votre abonnement.',
            descModalSubtitle: 'Il est important que notre technicien intervienne pour fermer votre branchement. Cette intervention sécurise l’installation. Vous pouvez ainsi quitter le logement en toute sérénité.',
            desModal: 'Si votre compteur est à l’intérieur de votre habitation, contactez-nous pour prendre rendez-vous.',
            desModalInd: 'Si votre compteur est accessible, il vous suffit de :',
            firstInd: 'Relever votre compteur',
            secondInd: 'Reporter le relevé correspondant au m3 sur ce formulaire',
            thirdInd: 'Nous indiquer votre nouvelle adresse',
            deadlineVld: 'Nous vous enverrons la facture soldant votre compte dans les meilleurs délais.',
            pendingRequestText1: 'Une demande de résiliation est déjà en cours de traitement.',
            pendingRequestText2: 'Celle-ci sera traitée sous peu.',
            validationBtn: 'J’ai compris',
            meterReading: 'Relevé de compteur',
            meterNumber: 'Matricule de votre compteur',
            readingDate: 'Date du relevé',
            redingDatePlaceholder: 'Date antérieure ou égale à ce jour',
            readingDateInput: 'Reportez les 4 à 6 chiffres indiqués sur votre compteur',
            newAdresse: 'Nouvelle adresse',
            currentDeliveryPointAddress: 'Adresse du branchement',
            confirmation: 'Confirmation',
            confirmationInd: 'Vous êtes sur le point de résilier votre abonnement. Merci de bien vérifier vos informations avant de valider.',
            modifyInput: 'Modifier ma saisie',
            confirmationCancelContract: 'Valider ma résiliation',
            contractCanceled: 'Votre branchement sera prochainement résilié et vous recevrez la facture soldant votre compte dans les meilleurs délais, à votre nouvelle adresse.',
            delayTerminatedContract: 'Votre espace client sera mis à jour sous 48 heures.'
        },
        removeContract: {
            title: 'Retirer ce contrat',
            message: 'Vous êtes sur le point de retirer le contrat suivant avec l’ensemble de ses branchements. Merci de vérifier les informations avant de cliquer sur le bouton « Retirer ce contrat ». Si vous souhaitez par la suite rajouter ce contrat, il vous suffira d’utiliser la fonction «Ajouter un contrat» dans l’onglet «Mon contrat».',
            warning: 'Les branchements liés à ce contrat vont être supprimés des familles concernées.',
            button: 'Retirer ce contrat',
            selectNewContract: 'Merci de sélectionner un contrat. Le dernier contrat sélectionné a été supprimé',
            selectNewContractFamily: 'Merci de sélectionner un contrat, ou une famille. Le dernier contrat ou famille sélectionné a été supprimé',
            confirmationMsg: 'Votre demande a été traitée'
        }
    },
    modal: {
        buttonCommmunicate: 'Communiquer mon relevé',
        lastMeter: 'Dernier relevé effectué le',
        instructionLine1: 'Reportez les 4 à 6 chiffres',
        instructionLine2: 'indiqués sur votre compteur',
        buttonValidate: 'Valider',
        indicationTitle: 'Mon compteur',
        matricule: 'Matricule du compteur',
        indicationHelp: 'Où trouver ces chiffres ?',
        indicationDescriptionPart1: 'Dans la case « relevé du compteur », ',
        indicationDescriptionPart2: 'reportez uniquement les 4 à 6 chiffres en blanc sur fond noir ou en noir sur fond blanc',
        indicationDescriptionPart3: '. Ils constituent le relevé que vous retrouvez sur votre facture, exprimé en m3 (1 m3=1000 l).',
        indicationDescription: 'Dans la case « relevé du compteur », reportez uniquement les 4 à 6 chiffres en blanc sur fond noir ou en noir sur fond blanc. Ils constituent le relevé que vous retrouvez sur votre facture, exprimé en m³ (1 m³=1000 l)',
        indicationDescription2: 'Merci de reporter les chiffres noirs de votre compteur',
        lastCounterNumber: 'Dernier relevé',
        numberToReportinm3: 'Nombre à reporter en m³',
        svgCounterFigure: {
            lastReport: 'Dernier relevé :',
            volume: 'Volume',
            inLitre: 'en litres',
            numbres: 'Chiffres',
            toReport: 'à reporter',
            volumeIn: 'Volume en',
            m3: 'm³'
        },
        levelInLiters: 'Niveau en litres',
        buttonBack: 'Revenir au relevé',
        addressTitle: 'Adresse du branchement',
        newMeter: 'Nouveau relevé',
        newMeterTitle: 'Nouveau relevé compteur',
        changeInput: 'Modifier ma saisie',
        greetings: 'Merci !',
        successMessage: 'Votre relevé a bien été transmis',
        successLine1: 'Les informations de votre compteur',
        successLine2: 'seront mises à jour prochainement',
        buttonFinish: 'Terminer',
        errorMessage: 'Erreur d’envoi',
        errorDesc: 'Veuillez réessayer plus tard',
        inputLengthError: 'Le relevé doit contenir minimum 4 chiffres',
        inputMeterError: 'Relevé inférieur au précédent',
        pictureModal: {
            pictureExtensionAlertTitle: 'Photo du compteur',
            pictureExtensionAlertMessage: "Le type de photo choisi n'est pas autorisé. Choisissez une autre photo au format JPEG  JPG.",
            permissionAlertTitle: 'Relevé du compteur',
            permissionAlertMessage: "Pour faciliter l'envoi de photo, Saur souhaite accéder à votre appareil photo et à votre bibliothèque. \nVous pourrez à tout moment modifier vos préférences en cliquant sur 'Préférences' dans les paramètres de l'application.",
            info: 'Impossible d’importer votre photo de compteur. Essayer de nouveau ou de continuer sans.',
            takeButton: 'Prendre une photo',
            importButton: 'Joindre une photo',
            withoutButton: 'Continuer sans photo',
            modifyPicture: 'Modifier ma photo',
            validateStatement: 'Valider le relevé',
            addPictureButton: 'Ajouter une photo',
            preferences: 'Préférences',
            takePictureOrJoinFileModalTitle: 'Prendre une photo de votre compteur ou joindre une photo de votre compteur au nouveau relevé.'
        },
        indexEntryBlockMessage: "Votre saisie d'index est en cours de traitement, vous devez attendre au moins 48h entre deux saisies d'index."
    },
    unsubscribe: {
        firstStep: {
            title1: 'Me désinscrire de l’espace client {brand}',
            title2: 'Vous êtes sur le point de supprimer définitivement votre espace client {brand}.',
            description1: 'Vous ne pourrez plus avoir accès aux fonctionnalités liées à votre consommation d’eau.',
            description2: 'La suppression de votre espace client n’implique pas la résiliation d’un ou de plusieurs contrats chez {brand}.',
            confirmationCheckbox: 'Je confirme ne plus vouloir avoir accès à mon espace client, ni recevoir d’information sur les services {brand}.',
            confirmButton: 'Valider'
        },
        secondStep: {
            title: 'Merci !',
            description1: 'Votre demande a bien été prise en compte.',
            description2: "Votre compte sera supprimé dans un délai de 24h, vous allez être redirigé vers la page d'authentification de l'espace client.",
            closeButton: 'Terminer'
        },
        errorStep: {
            errorMessage: "UNE ERREUR S'EST PRODUITE",
            errorDescriptionMessage: 'Un problème technique a empêché la validation de votre désinscription.',
            tryAgainMessage: 'Veuillez réessayer plus tard.',
            cancelButton: 'Fermer'
        }
    },
    sem: {
        family: {
            connections: 'Branchements',
            allConnections: 'Tous les branchements',
            searchFamily: 'Rechercher une famille',
            addFamily: 'Ajouter une famille',
            family: 'famille',
            telereleve: 'Télérelevé',
            nonTelereleve: 'Non télérelevé',
            families: 'Familles',
            cancelButton: 'Annuler',
            noFamilyExistsMessage: "Il n'existe aucune famille dans votre compte",
            delete: {
                title: 'Supprimer la famille',
                message: 'Voulez-vous supprimer « {family} » ?',
                warning: 'Si vous supprimez cette famille, vous dissociez tous les branchements à cette famille. Les branchements gardent leurs autres associations.',
                button: 'Supprimer'
            },
            sectionSubscription: {
                rename: {
                    title: 'Renommer le branchement',
                    Name: 'Nom',
                    button: 'Renommer',
                    errorMessage: {
                        required: 'Ce champs est requis',
                        maxLength: 'Le nom est limité à 50 caractères.',
                        minLength: 'Le nom doit être supérieur à 3 caractères.',
                        alreadyExists: 'Il existe déjà un branchement avec ce nom.'
                    }
                }
            },
            familyCreation: {
                createFamily: 'CRÉER UNE FAMILLE',
                familyName: 'Nom de la famille',
                findDelivery: 'Rechercher un branchement',
                createFamilyButton: 'Créer la famille',
                noSecSubFound: 'Aucun branchement correspondant à la recherche'
            },
            updateFamily: {
                updateFamily: 'MODIFIER UNE FAMILLE',
                updateFamilyButton: 'Modifier la famille'
            },
            errorMessages: {
                familyNameErrorMsg1: 'Le nom de la famille doit contenir plus de 3 caractères et moins de 50 caractères.',
                familyNameErrorMsg2: 'Il existe déjà une famille avec ce nom.',
                familySectionSubscriptionErrorMsg1: 'Veuillez sélectionner au moins un branchement.',
                familySectionSubscriptionErrorMsg2: 'Une famille ne peut pas avoir plusieurs types de branchement.',
                createFamilyCondition: 'La famille doit contenir au moins un branchement. Si vous souhaitez dissocier tous les branchements, veuillez supprimer cette famille.'
            }
        }
    },
    coachConso: {
        neighborComparison: {
            widgetTitle: 'Comparaison aux foyers similaires',
            smileyTitle: 'Votre consommation est',
            legendTitle: 'Qui sont les foyers similaires ?',
            waterLabel: 'Eau',
            consumptionTitle: 'Vous avez utilisé approximativement 120% plus d’eau que des foyers similaires',
            chartsYouLabel: 'Vous',
            chartsEfficientLabel: 'Foyers efficaces',
            chartsAverageLabel: 'Foyers moyens',
            smileysGreatText: 'Excellente',
            smileysGoodText: 'Bonne',
            smileysAverageGreatText: 'Plus élevée que la moyenne',
            legendFoyersEfficacesTitle: 'Foyers efficaces',
            legendFoyersEfficacesDescription: 'Les 20% de foyers les plus économes dans votre zone géographique qui ont {{occupancy}} occupant{{#pluralOccupancy}}s{{/pluralOccupancy}}',
            legendFoyersMoyensTitle: 'Foyers moyens',
            legendFoyersMoyensDescription: 'La moyenne des foyers avec {{occupancy}} occupant{{#pluralOccupancy}}s{{/pluralOccupancy}} dans votre zone géographique ',
            unit: 'mètres cubes'
        },
        disaggregation: {
            widgetTitle: 'Votre usage d’eau',
            title: 'Votre usage d’eau'
        },
        survey: {
            updateMyData: 'Mettre à jour mon foyer',
            neibhorComparisonInfo: 'Cette comparaison est basée sur les informations que nous avons de votre foyer',
            waterUseInfo: 'Il s’agit de votre usage moyen dans votre foyer. Nous avons estimé votre usage d’après différentes sources. Pour affiner cette estimation, veuillez compléter le profil de votre foyer',
            updateMyDataButton: 'Mettre à jour mon foyer',
            language: {
                progressBarTextFirstPart: 'Vous avez répondu à ',
                progressBarTextSecondPart: 'question(s) sur',
                privacy_note: '',
                updateButton: 'Mettre à jour mes informations',
                pleaseSelect: 'Veuillez sélectionner',
                alerts: {
                    success: 'Réponses soumises avec succès',
                    failed: 'Impossible de soumettre vos réponses',
                    upToDate: 'Les réponses sont à jour'
                }
            },
            errorMessages: {
                invalidData: "Données d'entrée non valides.",
                fetchError: 'Impossible de récupérer les données du serveur.'
            }
        },
        tips: {
            widgetTitle: "Conseils utiles pour économiser l'eau",
            readMore: 'Lire la suite',
            doItNow: 'Je vais le faire',
            next: 'Suivant',
            previous: 'Précédent',
            undo: 'Annuler',
            done: "Je l'ai fait",
            addFailed: "Erreur d'ajout au plan d'action"
        },
        tipsLibrary: {
            actionPlanTitle: "Mon plan d'action",
            actionPlanDescription: "Sélectionnez n'importe quel conseil pour l'ajouter à votre plan et suivre vos progrès.",
            completedTipsTitle: 'Complété',
            actionPlanReadMoreLabel: 'EN SAVOIR PLUS',
            actionPlanDoneLabel: "JE L'AI FAIT",
            readMoreButtonLabel: 'En savoir plus',
            undoButtonLabel: 'Annuler',
            doneButtonLabel: "JE L'AI FAIT",
            doItButtonLabel: 'Je vais le faire',
            undoTooltipLabel: 'Annuler le conseil',
            previousButtonLabel: 'Précédent',
            nextButtonLabel: 'Suivant',
            backBtnLabel: 'Retourner à mon coach conso',
            actionPlan: {
                addSuccess: "Astuce ajoutée au plan d'action",
                addFailed: "Erreur lors de l'ajout au plan d'action",
                completeSuccess: 'Astuce terminée',
                completeFailed: 'Erreur lors de la complétion du conseil',
                unCompleteSuccess: 'Action effectuée avec succès',
                unCompleteFailed: "Erreur lors de l'exécution de l'action",
                removeSuccess: "Astuce supprimée du plan d'action",
                removeFailed: "Erreur lors de la suppression du plan d'action",
                getTipsFailed: 'Erreur de chargement des conseils'
            }
        }
    },
    toast: {
        successMessage: 'Action réussie',
        failureMessage: "L'action a échoué"
    },
    deliveryPointRequests: {
        requestsTracking: 'SUIVI DES DEMANDES DE BRANCHEMENT',
        request: 'DEMANDE DE BRANCHEMENT'
    },
    clientIdentity: {
        title: 'Identité client',
        emailLabel: 'Email',
        mobilePhoneLabel: 'Téléphone mobile',
        landlineLabel: 'Téléphone fixe',
        billingAddressLabel: 'Adresse de correspondance',
        alreadyCanceled: 'Le compte est déjà résilié'
    }
};
